module.exports = __webpack_public_path__ + "static/media/Internationalpic1.8228a146.png";